import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '../public/locales/en/common.json';
import frCommon from '../public/locales/fr/common.json';
import enAssociations from '../public/locales/en/associations.json';
import frAssociations from '../public/locales/fr/associations.json';
import enOrganizations from '../public/locales/en/organizations.json';
import frOrganizations from '../public/locales/fr/organizations.json';
import enCheckout from '../public/locales/en/checkout.json';
import frCheckout from '../public/locales/fr/checkout.json';
import enEvents from '../public/locales/en/events.json';
import frEvents from '../public/locales/fr/events.json';
import enUsers from '../public/locales/en/users.json';
import frUsers from '../public/locales/fr/users.json';
import enValidations from '../public/locales/en/validations.json';
import frValidations from '../public/locales/fr/validations.json';
import enAuth from '../public/locales/en/auth.json';
import frAuth from '../public/locales/fr/auth.json';
import enDashboard from '../public/locales/en/dashboard.json';
import frDashboard from '../public/locales/fr/dashboard.json';
import enPayments from '../public/locales/en/payments.json';
import frPayments from '../public/locales/fr/payments.json';
import enSearch from '../public/locales/en/search.json';
import frSearch from '../public/locales/fr/search.json';

import enMarketing from '../public/locales/en/marketing.json';
import frMarketing from '../public/locales/fr/marketing.json';
import enForms from '../public/locales/en/forms.json';
import frForms from '../public/locales/fr/forms.json';

i18n
  .use({
    type: 'postProcessor',
    name: 'colon',
    process: (value, _, options) => {
      if (options.lng === 'fr') {
        return `${value} :`;
      }

      return `${value}:`;
    }
  })
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        associations: enAssociations,
        organizations: enOrganizations,
        checkout: enCheckout,
        events: enEvents,
        users: enUsers,
        validations: enValidations,
        auth: enAuth,
        dashboard: enDashboard,
        payments: enPayments,
        search: enSearch,
        forms: enForms,
        marketing: enMarketing
      },
      fr: {
        common: frCommon,
        associations: frAssociations,
        organizations: frOrganizations,
        checkout: frCheckout,
        events: frEvents,
        users: frUsers,
        validations: frValidations,
        auth: frAuth,
        dashboard: frDashboard,
        payments: frPayments,
        search: frSearch,
        forms: frForms,
        marketing: frMarketing
      }
    },
    lng:
      typeof window !== 'undefined'
        ? localStorage?.getItem('bounceSelectedLanguage') || 'en'
        : 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

export default i18n;
